import { Component, Input } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { ListGroupState, ListItemState, ListState } from '@usf/ngrx-list';
import { Observable } from 'rxjs';
import { CopyToListsModalComponent } from '../copy-to-lists-modal/copy-to-lists-modal.component';

import { ProductRow } from '../../shared/list-detail-management/model/list-detail-management-view.model';
import { CopyToGroupsModalComponent } from '../copy-to-groups-modal/copy-to-groups-modal.component';
@Component({
  selector: 'app-copy-products-modal',
  templateUrl: './copy-products-modal.component.html',
  styleUrls: ['./copy-products-modal.component.scss'],
})
export class CopyProductsModalComponent {
  @Input() selectedProducts: ProductRow[];
  @Input() list: ListState;
  @Input() title: string;
  @Input() groups: ListGroupState[];
  @Input() selectedGroup: ListGroupState;
  @Input() listItems: ListItemState[];
  @Input() platform: PlatformEnum;
  @Input() dismissFunc: Function;
  @Input() getListData: Function;
  @Input() getListsLoaded: Function;
  @Input() isOpen: Observable<boolean>;
  @Input() finalSubmission: Function;
  @Input() enableCopyToList: boolean;
  @Input() hideCopyToListOption: boolean;

  platformRef = PlatformEnum;
  selection: string;

  constructor(private ionNav: IonNav) {}

  dismissModal() {
    this.dismissFunc();
  }

  next() {
    if (this.selection === 'group')
      this.ionNav.push(CopyToGroupsModalComponent, {
        platform: this.platform,
        list: this.list,
        dismissFunc: this.dismissFunc,
        groups: this.groups,
        selectedGroup: this.selectedGroup,
        title: this.title,
        selectedProducts: this.selectedProducts,
        listItems: this.listItems,
      });

    if (this.selection === 'list')
      this.ionNav.push(CopyToListsModalComponent, {
        platform: this.platform,
        dismissFunc: this.dismissFunc,
        getListData: this.getListData,
        getListsLoaded: this.getListsLoaded,
        title: this.title,
        selectedProducts: this.selectedProducts,
        finalSubmission: this.finalSubmission,
      });
  }
}
